// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__1TqPP","innerWrapper":"button_innerWrapper__2gX52"};